<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/solutions/` : "/api/solutions/"
const { data } = await useFetch(apiUrl, { key: "home-solutions" })

const resolveImageUrl = (url) => {
  if (!url) return ""
  if (/^https?:\/\//i.test(url)) return url
  if (url.startsWith("/media/")) return url
  return url
}

const buildSrcset = (srcset) => {
  if (!srcset || !Array.isArray(srcset) || srcset.length === 0) return ""
  return srcset
    .map((item) => `${resolveImageUrl(item.url)} ${item.w}w`)
    .join(", ")
}

const sectionData = computed(() => data.value?.section || null)
const cardsData = computed(() => (data.value?.cards?.length ? data.value.cards : []))
</script>

<template>
  <section v-if="sectionData" class="section-solution">
    <div
      class="section__title"
      style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);"
    >
      <div
        class="title__text__wrapper width-577"
        style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);"
      >
        <h2 class="title__text__h2">
          <span class="color-span-scorpion">{{ sectionData.title_prefix }}</span>
          {{ sectionData.title_suffix }}
        </h2>
      </div>
      <div
        class="title__description__wrapper width-426"
        style="translate: none; rotate: none; scale: none; opacity: 1; transform: translate(0px, 0%);"
      >
        <div class="text-regular-18" v-html="sectionData.subtitle"></div>
      </div>
    </div>

    <div class="solution__container">
      <div v-for="card in cardsData" :key="card.id || card.title" class="solution__card">
        <div class="solution__card__img-wrapper">
          <img
            :src="resolveImageUrl(card.image_url)"
            :srcset="buildSrcset(card.image_srcset)"
            sizes="(max-width: 479px) 93vw, (max-width: 767px) 73vw, (max-width: 991px) 79vw, (max-width: 1365px) 81vw, 1106px"
            loading="lazy"
            :alt="card.image_alt || card.title"
            class="image-cover"
          >
        </div>
        <div class="solution__card__info-block">
          <div class="solution__card__info-block__title">
            <div class="solution__card__info-block__title__text">
              <h4>{{ card.title }}</h4>
              <div class="text-regular-16" v-html="card.description"></div>
            </div>
            <div class="solution__card__info-block__bottom">
              <div v-for="tag in (card.tags || [])" :key="tag">
                <div class="card-tag">
                  <p class="text-regular-16">{{ tag }}</p>
                </div>
              </div>
            </div>
            <div
              data-openform
              data-wf--button--variant="full-width"
              class="button-classic w-variant-2537139b-b11b-5f0d-26f2-9c95528a416f"
            >
              <p>{{ sectionData.button_label || "Зв’язатись" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="solutions" class="scroll-anchor"></div>
  </section>
</template>

<style lang="scss" scoped>
@use "/assets/scss/sections/_solutions.scss";
</style>
